import type { DeckDef } from "@/decks/types";

// Deck de prospección: abre conversaciones con dueños y gerencia de retail/distribución.
// Estructura fija (16 slides). El copy vive en messages/es.json (deck.prospeccion.*) y es
// placeholder hasta la fase de contenido. Mover una slide = mover su línea; ocultar = hidden: true.
export const prospeccionDeck: DeckDef = {
  id: "prospeccion",
  listed: true,
  languages: ["es"],
  slides: [
    // Entrada
    { id: "portada", load: () => import("./slides/PortadaSlide") },
    { id: "resumen", load: () => import("./slides/ResumenSlide"), fragments: 3 },
    // Problema
    { id: "problema", load: () => import("./slides/ProblemaSlide"), fragments: 2 },
    { id: "limite-metodo", load: () => import("./slides/LimiteMetodoSlide"), fragments: 2 },
    // Producto y solución
    { id: "que-es", load: () => import("./slides/QueEsSlide") },
    { id: "como-funciona", load: () => import("./slides/ComoFuncionaSlide"), fragments: 3 },
    { id: "que-incluye", load: () => import("./slides/QueIncluyeSlide"), fragments: 4 },
    // Outputs
    { id: "entregables", load: () => import("./slides/EntregablesSlide"), fragments: 3 },
    // Posicionamiento
    { id: "posicionamiento", load: () => import("./slides/PosicionamientoSlide"), fragments: 3 },
    // Valor agregado
    { id: "impacto", load: () => import("./slides/ImpactoSlide"), fragments: 3 },
    { id: "medicion", load: () => import("./slides/MedicionSlide"), fragments: 3 },
    // Evidencia
    { id: "historia", load: () => import("./slides/HistoriaSlide"), fragments: 3 },
    // Adopción
    { id: "integracion", load: () => import("./slides/IntegracionSlide"), fragments: 3 },
    { id: "riesgo-confianza", load: () => import("./slides/RiesgoConfianzaSlide"), fragments: 3 },
    // Cierre
    { id: "piloto", load: () => import("./slides/PilotoSlide"), fragments: 3 },
    { id: "cierre", load: () => import("./slides/CierreSlide") },
  ],
};
